import React, { useEffect, useState } from "react";
import "../../../src/style.css";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Box,
  Chip,
  Card,
  Grid,
  Typography,
  Skeleton,
  Stack,
  styled,
  IconButton,
} from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CallMissedIcon from "@mui/icons-material/CallMissed";
import axios from "axios";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

import { api } from "../../mockData";
import dayjs from "dayjs";
import AddIcCall from "@mui/icons-material/AddIcCall";
import Call from "@mui/icons-material/Call";
import CallEnd from "@mui/icons-material/CallEnd";
import CallMissed from "@mui/icons-material/CallMissed";
import PhoneCallback from "@mui/icons-material/PhoneCallback";
import PhoneDisabled from "@mui/icons-material/PhoneDisabled";
import CallDistributionPie from "../../components/chart/CallDistributionPie";
import HangupReasonBar from "../../components/chart/HangupReasonBar";
import CallsByHourLine from "../../components/chart/CallsByHourLine";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 15,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[400],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#0a140e",
    ...theme.applyStyles("dark", {
      backgroundColor: "#308fe8",
    }),
  },
}));

function Dashboard({ chartData, userThem }) {
  const state = useSelector((state) => state?.user);
  const current_user = localStorage.getItem("current_user");
  const user = JSON.parse(localStorage.getItem(`user_${current_user}`));
  const location = useLocation();
  const data = location?.state;
  const [visibleCount, setVisibleCount] = React.useState(3);
  const [visibleCount1, setVisibleCount1] = React.useState(5);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 2);
  };

  const handleLoadLess = () => {
    setVisibleCount((prev) => Math.max(prev - 2, 3)); // minimum 3 items
  };

  const handleLoadMore1 = () => {
    setVisibleCount1((prev) => prev + 2);
  };

  const handleLoadLess1 = () => {
    setVisibleCount1((prev) => Math.max(prev - 2, 3)); // minimum 3 items
  };

  const [tollFree, setTollFree] = useState([]);
  const [local, setLocal] = useState([]);
  const [callSummary, setCallSummary] = useState({});
  const [callSummaryYesterday, setCallSummaryYesterday] = useState({});
  const [dataVal, setDataVal] = useState([]);
  // Separate 7-day CDR pull powering only the Hangup Reasons chart so the
  // other widgets (Calls by Hour, Recent Report) stay scoped to today.
  const [weekRecords, setWeekRecords] = useState([]);
  const [didProg, setDidProg] = useState([]);
  const records = dataVal?.data?.records || [];
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    let isMounted = true; // 🔒 prevent state update after unmount

    const fetchData = async () => {
      setLoader(true); // ✅ show loader

      try {
        const config2 = {
          method: "get",
          url: `${api.dev}/api/calls_summary`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.access_token}`,
          },
        };

        const config3 = {
          method: "post",
          url: `${api.dev}/api/userallcdr`,
          data: {
            from_date: dayjs().startOf("day").format("YYYY-MM-DD HH:mm"),
            to_date: dayjs().endOf("day").format("YYYY-MM-DD HH:mm"),
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.access_token}`,
          },
        };

        const config4 = {
          method: "get",
          url: `${api.dev}/api/did_progress_bar`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.access_token}`,
          },
        };

        // Yesterday's totals — feeds the per-card "▲ X% vs yesterday" deltas
        // by hitting the same /api/calls_summary endpoint with ?date=.
        const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
        const config5 = {
          method: "get",
          url: `${api.dev}/api/calls_summary?date=${yesterday}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.access_token}`,
          },
        };

        // Last 7 days of CDR — feeds Hangup Reasons chart only. Pulled on a
        // separate request so the today-scoped widgets keep their narrow
        // window and this one gets the wider trend view.
        const config6 = {
          method: "post",
          url: `${api.dev}/api/userallcdr`,
          data: {
            from_date: dayjs()
              .subtract(6, "day")
              .startOf("day")
              .format("YYYY-MM-DD HH:mm"),
            to_date: dayjs().endOf("day").format("YYYY-MM-DD HH:mm"),
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.access_token}`,
          },
        };

        const results = await Promise.allSettled([
          axios.request(config2),
          axios.request(config3),
          axios.request(config4),
          axios.request(config5),
          axios.request(config6),
        ]);

        const [
          callSummaryRes,
          recentReportRes,
          did_progress_barRes,
          callSummaryYesterdayRes,
          weekRecordsRes,
        ] = results;

        if (isMounted) {
          // ✅ calls summary
          if (callSummaryRes.status === "fulfilled") {
            setCallSummary(callSummaryRes.value.data);
          } else {
            console.error("Call Summary API failed", callSummaryRes.reason);
            setCallSummary(null);
          }

          // ✅ recent report
          if (recentReportRes.status === "fulfilled") {
            setDataVal(recentReportRes.value.data);
          } else {
            console.error("Recent Report API failed", recentReportRes.reason);
            setDataVal([]);
          }

          // did_progress_bar

          if (did_progress_barRes.status === "fulfilled") {
            setDidProg(did_progress_barRes.value.data);
          } else {
            console.error(
              "Did Progress bar API failed",
              did_progress_barRes.reason,
            );
            setDidProg([]);
          }

          // yesterday — soft-fail; deltas just show "—" if this dies.
          if (callSummaryYesterdayRes.status === "fulfilled") {
            setCallSummaryYesterday(callSummaryYesterdayRes.value.data);
          } else {
            console.error(
              "Call Summary (yesterday) API failed",
              callSummaryYesterdayRes.reason,
            );
            setCallSummaryYesterday({});
          }

          // 7-day CDR for Hangup Reasons — soft-fail to empty so the chart
          // shows its no-data placeholder rather than blocking the dashboard.
          if (weekRecordsRes.status === "fulfilled") {
            setWeekRecords(weekRecordsRes.value.data?.data || []);
          } else {
            console.error(
              "Week CDR (7d) API failed",
              weekRecordsRes.reason,
            );
            setWeekRecords([]);
          }
        }
      } catch (error) {
        console.error("Unexpected API Error:", error);
      } finally {
        if (isMounted) {
          setLoader(false); // ✅ hide loader safely
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false; // cleanup
    };
  }, [user?.access_token]);

  // Computes a "vs yesterday" delta for a KPI card.
  // Returns null when no comparison is meaningful (yesterday = today = 0,
  // or yesterday data hasn't loaded yet) — the StatCard then hides the chip.
  // - isPositiveMetric: true for metrics where "more is better" (Total, Answered, Unique).
  //   The good/bad coloring inverts this for negative metrics (Missed, Failed).
  const computeDelta = (todayVal, yesterdayVal, isPositiveMetric) => {
    const t = Number(todayVal) || 0;
    const y = Number(yesterdayVal) || 0;
    if (t === 0 && y === 0) return null;
    const diff = t - y;
    let percent = null;
    if (y > 0) percent = Math.round((diff / y) * 100);
    return {
      diff,
      percent, // null when yesterday was 0 (avoid divide-by-zero / Infinity)
      direction: diff > 0 ? "up" : diff < 0 ? "down" : "flat",
      isPositiveMetric,
    };
  };

  const yData = callSummaryYesterday?.data || {};
  const tData = callSummary?.data || {};

  const callStats = [
    {
      title: "Total Calls",
      value: tData.Total ?? 0,
      subValue: "Today",
      icon: CallIcon,
      accent: "#1976d2",
      delta: computeDelta(tData.Total, yData.Total, true),
    },
    {
      title: "Unique Calls",
      value: tData.total_uniqe_call ?? 0,
      subValue: "Distinct today",
      icon: FingerprintIcon,
      accent: "#7c3aed",
      delta: computeDelta(tData.total_uniqe_call, yData.total_uniqe_call, true),
    },
    {
      title: "Answered Calls",
      value: tData.Answered ?? 0,
      subValue: "Successful",
      icon: CallReceivedIcon,
      accent: "#2e7d32",
      delta: computeDelta(tData.Answered, yData.Answered, true),
    },
    {
      title: "Missed Calls",
      values: {
        missed: tData.Missed ?? 0,
      },
      subValue: "Needs attention",
      icon: CallMissed, // ❌ call not received
      accent: "#f59e0b", // Amber / Warning
      delta: computeDelta(tData.Missed, yData.Missed, false),
    },

    {
      title: "Failed Calls",
      values: {
        failed: tData.Failed ?? 0,
      },
      subValue: "Needs attention",
      icon: CallEnd, // ❌ call failed
      accent: "#dc2626", // Red / Error
      delta: computeDelta(tData.Failed, yData.Failed, false),
    },

    {
      title: "Active DID Number",
      values: {
        active_did: tData.total_active_didnumber ?? 0,
      },
      subValue: "Currently active",
      icon: Call, // ✅ active call
      accent: "#16a34a", // Green (success)
      // No delta — Active DIDs is a current-state metric, not period-based.
    },
  ];

  // Renders the "▲ 12% vs yesterday" line below a KPI value.
  // Color encodes good-vs-bad: positive metrics green-up/red-down,
  // negative metrics (Missed, Failed) inverted.
  const DeltaIndicator = ({ delta }) => {
    if (!delta) return null;
    const { percent, diff, direction, isPositiveMetric } = delta;
    const arrow = direction === "up" ? "▲" : direction === "down" ? "▼" : "—";
    const isGoodChange =
      direction === "flat"
        ? null
        : isPositiveMetric
          ? direction === "up"
          : direction === "down";
    const color =
      isGoodChange === null
        ? "#94a3b8"
        : isGoodChange
          ? "#16a34a"
          : "#dc2626";
    const label =
      direction === "flat"
        ? "no change"
        : percent === null
          ? `${diff > 0 ? "+" : ""}${diff}`
          : `${Math.abs(percent)}%`;
    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          mt: 0.4,
          px: 0.8,
          py: 0.1,
          borderRadius: "6px",
          background: `${color}14`,
        }}
      >
        <Typography sx={{ fontSize: 11, fontWeight: 700, color, lineHeight: 1.1 }}>
          {arrow} {label}
        </Typography>
        <Typography sx={{ fontSize: 10, color: "#64748b", lineHeight: 1.1 }}>
          vs yesterday
        </Typography>
      </Box>
    );
  };

  const StatCard = ({ title, value, values, icon: Icon, accent, delta }) => {
    return (
      <Card
        sx={{
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          // Padding scales so cards stay legible when zoomed (CSS Grid
          // forces N columns to share width, so each card shrinks).
          p: "clamp(0.55rem, 1.1vw, 1rem)",
          borderRadius: "20px",
          backgroundColor: "#fff",
          position: "relative",
          overflow: "hidden",
          boxShadow: `0 8px 32px ${accent}22`,
          border: `1px solid ${accent}22`,
          transition: "all 0.35s ease",
          cursor: "pointer",
          minWidth: 0,

          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: `0 20px 40px ${accent}33`,
          },

          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "6px",
            height: "100%",
            backgroundColor: accent,
            borderTopLeftRadius: "20px",
            borderBottomLeftRadius: "20px",
          },
        }}
      >
        {/* Two-row layout: full-width title on top, then value + icon
            sharing the second row. Title gets dedicated horizontal space
            so it doesn't compete with the icon and stays readable when
            the card narrows. Delta chip sits below value in the same
            second row's left column. */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "clamp(2px, 0.4vw, 6px)", minWidth: 0, position: "relative", zIndex: 1 }}>
          <Typography
            sx={{
              fontSize: "clamp(0.7rem, 0.95vw, 0.85rem)",
              fontWeight: 700,
              textTransform: "capitalize",
              color: accent,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              ".App.user_theme_white &": {
                color: "#0f172a!important",
              },
            }}
          >
            {title}
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "clamp(4px, 0.6vw, 10px)",
              minWidth: 0,
            }}
          >
            <Box sx={{ minWidth: 0, overflow: "hidden", flex: 1 }}>
              {value !== undefined && (
                <Typography
                  sx={{
                    fontSize: "clamp(1.1rem, 2.2vw, 1.9rem)",
                    fontWeight: 700,
                    color: "#1f2937",
                    lineHeight: 1.15,
                  }}
                >
                  {value}
                </Typography>
              )}

              {values && (
                <Typography
                  sx={{
                    fontSize: "clamp(1rem, 2.1vw, 1.8rem)",
                    fontWeight: 700,
                    color: "#374151",
                    lineHeight: 1.15,
                  }}
                >
                  {values.missed} {values.failed} {values.busy}{" "}
                  {values.active_did}
                </Typography>
              )}

              <DeltaIndicator delta={delta} />
            </Box>

            {/* Icon — smaller max than before since title no longer
                competes for vertical space inside the row. */}
            <Box
              sx={{
                width: "clamp(32px, 3.2vw, 52px)",
                height: "clamp(32px, 3.2vw, 52px)",
                flexShrink: 0,
                borderRadius: "clamp(9px, 1.2vw, 14px)",
                backgroundColor: `${accent}15`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `2px solid ${accent}30`,
              }}
            >
              <Icon sx={{ fontSize: "clamp(16px, 1.9vw, 23px)", color: accent }} />
            </Box>
          </Box>
        </Box>
      </Card>
    );
  };

  const StatCardSkeleton = () => {
    return (
      <Card
        sx={{
          width: "100%",
          height: "100%",
          boxSizing: "border-box",
          p: "clamp(0.55rem, 1.1vw, 1rem)",
          borderRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          minWidth: 0,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "clamp(2px, 0.4vw, 6px)", minWidth: 0 }}>
          {/* Title row */}
          <Skeleton width="70%" height={16} />
          {/* Value + icon row */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "clamp(4px, 0.6vw, 10px)",
              minWidth: 0,
            }}
          >
            <Skeleton width="55%" height={32} sx={{ flex: "1 1 auto" }} />
            <Skeleton
              variant="rounded"
              sx={{
                width: "clamp(32px, 3.2vw, 52px)",
                height: "clamp(32px, 3.2vw, 52px)",
                flexShrink: 0,
              }}
            />
          </Box>
        </Box>
      </Card>
    );
  };

  const TableSkeleton = () => {
    return (
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              {Array.from({ length: 4 }).map((_, i) => (
                <th key={i}>
                  <Skeleton width="80%" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 5 }).map((_, rowIndex) => (
              <tr key={rowIndex}>
                {Array.from({ length: 4 }).map((_, colIndex) => (
                  <td key={colIndex}>
                    <Skeleton />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // Call Performance Skeleton Component
  const CallPerformanceSkeleton = () => {
    return (
      <Box>
        {Array.from({ length: visibleCount }).map((_, index) => (
          <Box
            key={index}
            sx={{
              mb: 1,
              p: 1.4,
              borderRadius: 2,
              background: "#f8fafc",
              border: "1px solid #e5e7eb",
            }}
          >
            {/* Header row skeleton */}
            <Box sx={{ display: "flex", gap: 2, mb: 0.8 }}>
              <Skeleton width={150} height={20} />
              <Skeleton width={100} height={20} />
            </Box>

            {/* Progress bar skeleton */}
            <Box sx={{ position: "relative" }}>
              <Skeleton
                variant="rounded"
                height={20}
                width="100%"
                sx={{ borderRadius: "2px" }}
              />

              {/* Percentage label skeleton */}
              <Skeleton
                width={40}
                height={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  borderRadius: 1,
                }}
              />
            </Box>
          </Box>
        ))}
      </Box>
    );
  };



  const tableData = [
    {
      did_number: "18773362192",
      forwarded_number: "9876543210",
      status: "Connected",
      start_at: "2025-01-22T10:15:00",
    },
    {
      did_number: "18773362193",
      forwarded_number: "9123456789",
      status: "Missed",
      start_at: "2025-01-22T10:30:00",
    },
    {
      did_number: "18773362194",
      forwarded_number: "9988776655",
      status: "Failed",
      start_at: "2025-01-22T10:45:00",
    },
    {
      did_number: "18773362195",
      forwarded_number: "9090909090",
      status: "Connected",
      start_at: "2025-01-22T11:00:00",
    },
    {
      did_number: "18773362196",
      forwarded_number: "9000011111",
      status: "Missed",
      start_at: "2025-01-22T11:15:00",
    },
    {
      did_number: "18773362197",
      forwarded_number: "9111122222",
      status: "Connected",
      start_at: "2025-01-22T11:30:00",
    },
  ];

  const pulseWarn1 = {
    "@keyframes pulseWarn1": {
      "0%": { boxShadow: "0 0 0 0 rgb(0, 172, 120)" },
      "70%": { boxShadow: "0 0 0 8px rgba(234,179,8,0)" },
      "100%": { boxShadow: "0 0 0 0 rgba(234,179,8,0)" },
    },
  };

  const pulseWarn = {
    "@keyframes pulseWarn": {
      "0%": { boxShadow: "0 0 0 0 rgba(234,179,8,0.6)" },
      "70%": { boxShadow: "0 0 0 8px rgba(234,179,8,0)" },
      "100%": { boxShadow: "0 0 0 0 rgba(234,179,8,0)" },
    },
  };

  return (
    <>
      {user?.user_role === "client" || "User" ? (
        <>
          <div className={`App ${userThem} `}>
            <div className="contant_box">
              <section className="sidebar-sec">
                <div className="container-fluid">
                  <div className="row justify-content-center">
                    <div className="col-lg-12">
                      <div className="">
                        <div className="tab_cntnt_box">
                          {/* <div className="cntnt_title">
                          <h3>Dashboard</h3>
                        </div> */}
                        </div>
                      </div>
                    </div>
                    <Grid container spacing={2}>
                      {/* Total Calls */}

                      <Grid item xs={12} md={12}>
                        <Box
                          className="d-flex justify-content-between flex-wrap mb-3"
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            gap: { xs: 1.5, md: 0 },
                            alignItems: { xs: "flex-start", md: "center" },
                          }}
                        >
                          {/* LEFT */}
                          <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                            <Chip
                              label="Call Summary"
                              sx={{
                                px: 2,
                                py: 1,
                                fontWeight: 600,
                                background:
                                  "linear-gradient(135deg, #0a140e 0%, #0a140e 100%)",
                                color: "#fff",
                                fontSize: "0.85rem",
                                letterSpacing: 0.5,
                                width: { xs: "100%", md: "auto" }, // 📱 full width
                                justifyContent: "center",
                              }}
                            />
                          </Box>

                          {/* RIGHT */}
                          <Box
                            sx={{
                              width: { xs: "100%", sm: "auto" },
                              mt: { xs: 1, sm: 0 },
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: { xs: "12px", sm: "13px" },
                                fontWeight: 600,
                                px: { xs: 1.5, sm: 2 },
                                py: 0.8,
                                borderRadius: "8px",
                                backgroundColor: "#1976d215",
                                color: "#0e397f",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                                position: "relative",
                                overflow: "hidden",
                                width: { xs: "100%", sm: "auto" },
                                justifyContent: {
                                  xs: "center",
                                  sm: "flex-start",
                                },
                                textAlign: "center",

                                ".App.user_theme_white &": {
                                  backgroundColor: "#1976d269",
                                },

                                "&::before": {
                                  content: '""',
                                  position: "absolute",
                                  left: 0,
                                  top: 0,
                                  height: "100%",
                                  width: "4px",
                                  backgroundColor: "#1976d2",
                                  borderRadius: "4px",
                                },

                                animation:
                                  "shrinkPulse 2.8s ease-in-out infinite",

                                "@keyframes shrinkPulse": {
                                  "0%": { transform: "scale(1)", opacity: 1 },
                                  "50%": {
                                    transform: "scale(0.97)",
                                    opacity: 0.85,
                                  },
                                  "100%": { transform: "scale(1)", opacity: 1 },
                                },
                              }}
                            >
                              Note: Refresh Time 00:00 am to 11:59 pm.
                            </Typography>
                          </Box>
                        </Box>{" "}
                        {/* CSS Grid (not flex+wrap) so the row never breaks
                            to a second line when zoomed. minmax(0, 1fr) lets
                            each column shrink uniformly; StatCard's content
                            is clamp()-scaled so icon + value stay legible at
                            smaller widths. overflow-x: auto is the safety
                            net at extreme zoom (175%+) — horizontal scroll
                            instead of wrap. */}
                        <Box
                          className="stat_cards_container"
                          sx={{
                            display: "grid",
                            gridTemplateColumns: {
                              xs: "repeat(2, minmax(0, 1fr))",
                              sm: "repeat(3, minmax(0, 1fr))",
                              md: "repeat(6, minmax(0, 1fr))",
                            },
                            gap: "10px",
                            alignItems: "stretch",
                            overflowX: "auto",
                          }}
                        >
                          {loader
                            ? Array.from({ length: 6 }).map((_, index) => (
                                <StatCardSkeleton key={index} />
                              ))
                            : callStats.map((item, index) => (
                                <StatCard key={index} {...item} />
                              ))}
                        </Box>{" "}
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} className="mt-4">
                      {/* Hangup-reason bar — granular breakdown of cdr.status across the last 7 days */}
                      <Grid item xs={12} md={6}>
                        <Chip
                          label="Hangup Reasons · Last 7 Days"
                          sx={{
                            px: 2,
                            mb: 2,
                            py: 1,
                            fontWeight: 600,
                            background:
                              "linear-gradient(135deg, #0a140e 0%, #0a140e 100%)",
                            color: "#fff",
                            fontSize: "0.85rem",
                            letterSpacing: 0.5,
                          }}
                        />
                        <Box
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            background: "#fff",
                            border: "1px solid #e5e7eb",
                            ".App.user_theme_white &": {
                              background: "#1e2a3a",
                              borderColor: "#2a3a4a",
                            },
                          }}
                        >
                          {loader ? (
                            <Skeleton variant="rounded" height={380} sx={{ borderRadius: 2 }} />
                          ) : (
                            <HangupReasonBar
                              records={weekRecords}
                              isDark={userThem === "user_theme_white"}
                            />
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Chip
                          label="Calls by Hour"
                          sx={{
                            px: 2,
                            mb: 2,
                            py: 1,
                            fontWeight: 600,
                            background:
                              "linear-gradient(135deg, #0a140e 0%, #0a140e 100%)",
                            color: "#fff",
                            fontSize: "0.85rem",
                            letterSpacing: 0.5,
                          }}
                        />
                        <Box
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            background: "#fff",
                            border: "1px solid #e5e7eb",
                            ".App.user_theme_white &": {
                              background: "#1e2a3a",
                              borderColor: "#2a3a4a",
                            },
                          }}
                        >
                          {loader ? (
                            <Skeleton variant="rounded" height={320} sx={{ borderRadius: 2 }} />
                          ) : (
                            <CallsByHourLine
                              records={dataVal?.data || []}
                              isDark={userThem === "user_theme_white"}
                            />
                          )}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            gap: { xs: 1.5, md: 0 },
                            alignItems: { xs: "flex-start", md: "center" },
                          }}
                        >
                          {/* Left: Title */}
                          <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                            <Chip
                              label="Call Performance"
                              sx={{
                                px: 2,
                                mb: 2,
                                py: 1,
                                fontWeight: 600,
                                background:
                                  "linear-gradient(135deg, #0a140e 0%, #0a140e 100%)",
                                color: "#fff",
                                fontSize: "0.85rem",
                                letterSpacing: 0.5,
                                width: { xs: "100%", md: "auto" }, // 📱 full width
                                justifyContent: "center",
                              }}
                            />
                          </Box>
                        </Box>

                        {/* Call Performance Skeleton Loader */}
                        {loader ? (
                          <CallPerformanceSkeleton />
                        ) : didProg?.data?.length > 0 ? (
                          didProg?.data
                            ?.slice(0, visibleCount)
                            .map((item, index) => {
                              const percent = Math.round(item.percent);

                              return (
                                <Box
                                  className="call_performance_card"
                                  key={index}
                                  sx={{
                                    mb: 1,
                                    p: 1.4,
                                    borderRadius: 2,
                                    background: "#f8fafc",
                                    border: "1px solid #e5e7eb",
                                    transition: "0.25s",
                                    "&:hover": {
                                      background: "#f1f5f9",
                                      transform: "translateY(-2px)",
                                    },
                                  }}
                                >
                                  {/* Header row */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: 2,
                                      mb: 0.8,
                                    }}
                                  >
                                    <Typography
                                      fontWeight={700}
                                      fontSize="13px"
                                    >
                                      DID: {item.did_number}
                                    </Typography>

                                    <Typography
                                      fontSize="12px"
                                      fontWeight={700}
                                    >
                                      Total Calls: <b>{item.calls}</b>
                                    </Typography>
                                    <Typography
                                      fontSize="12px"
                                      fontWeight={700}
                                    >
                                      Answered Calls: <b>{item.answered}</b>
                                    </Typography>
                                    <Typography
                                      fontSize="12px"
                                      fontWeight={700}
                                    >
                                      Failed Calls: <b>{item.failed}</b>
                                    </Typography>
                                    <Typography
                                      fontSize="12px"
                                      fontWeight={700}
                                    >
                                      Missed Calls: <b>{item.missed}</b>
                                    </Typography>
                                  </Box>

                                  {/* Progress bar */}
                                  <Box sx={{ position: "relative" }}>
                                    <BorderLinearProgress
                                      variant="determinate"
                                      value={percent}
                                      sx={{
                                        height: 20,
                                        borderRadius: "2px",
                                        backgroundColor: "#e5e7eb",
                                        "& .MuiLinearProgress-bar": {
                                          borderRadius: "2px",
                                          background:
                                            percent >= 50
                                              ? "linear-gradient(90deg, #16a34a, #22c55e)" // 🟢 Green (>=50)
                                              : "linear-gradient(90deg, #dc2626, #ef4444)", // 🔴 Red (<50)

                                          boxShadow:
                                            percent >= 70
                                              ? "0 0 10px rgba(34,197,94,0.6)"
                                              : percent >= 40
                                                ? "0 0 8px rgba(249,115,22,0.5)"
                                                : "0 0 8px rgba(239,68,68,0.6)",
                                          animation:
                                            percent >= 70
                                              ? "pulseWarn1 1.4s infinite"
                                              : "pulseWarn 1.6s infinite",
                                        },
                                      }}
                                    />

                                    {/* Percentage label */}
                                    <Typography
                                      sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: `clamp(4%, ${percent}%, 95.8%)`,
                                        transform: "translate(-50%, -50%)",
                                        fontSize: "12px",
                                        fontWeight: 700,
                                        px: 1,
                                        borderRadius: 1,
                                        color:
                                          percent > 50 ? "#065f46" : "#92400e",
                                        background:
                                          percent > 50 ? "#ecfdf5" : "#fffbeb",
                                        animation:
                                          percent > 50
                                            ? "pulseWarn1 1.3s infinite"
                                            : "pulseWarn 1.6s infinite",
                                      }}
                                    >
                                      {percent}%
                                    </Typography>
                                  </Box>
                                </Box>
                              );
                            })
                        ) : (
                          <Box
                            sx={{
                              textAlign: "center",
                              py: 3,
                              color: "text.secondary",
                              border: "1px dashed #e5e7eb",
                              borderRadius: 2,
                              backgroundColor: "#f9fafb",
                            }}
                          >
                            <Typography>
                              No call performance data available
                            </Typography>
                          </Box>
                        )}

                        {/* Load More / Less - Only show when not loading and has data */}
                        {!loader && didProg?.data?.length > 3 && (
                          <Box
                            textAlign="center"
                            mt={2}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              gap: 1,
                            }}
                          >
                            {visibleCount > 3 && (
                              <IconButton
                                className="filter_reset_btn"
                                onClick={handleLoadLess}
                              >
                                Load Less
                              </IconButton>
                            )}

                            {visibleCount < didProg?.data?.length && (
                              <IconButton
                                className="redirect_all_button_clr"
                                onClick={handleLoadMore}
                              >
                                Load More
                              </IconButton>
                            )}
                          </Box>
                        )}
                      </Grid>

                      {/* Call Distribution — 3D donut summary of today's calls */}
                      <Grid item xs={12} md={6}>
                        <Chip
                          label="Call Distribution"
                          sx={{
                            px: 2,
                            mb: 2,
                            py: 1,
                            fontWeight: 600,
                            background:
                              "linear-gradient(135deg, #0a140e 0%, #0a140e 100%)",
                            color: "#fff",
                            fontSize: "0.85rem",
                            letterSpacing: 0.5,
                          }}
                        />
                        <Box
                          sx={{
                            p: 2,
                            borderRadius: 2,
                            background: "#fff",
                            border: "1px solid #e5e7eb",
                            ".App.user_theme_white &": {
                              background: "#1e2a3a",
                              borderColor: "#2a3a4a",
                            },
                          }}
                        >
                          {loader ? (
                            <Skeleton variant="rounded" height={380} sx={{ borderRadius: 2 }} />
                          ) : (
                            <CallDistributionPie
                              answered={callSummary?.data?.Answered ?? 0}
                              missed={callSummary?.data?.Missed ?? 0}
                              failed={callSummary?.data?.Failed ?? 0}
                              isDark={userThem === "user_theme_white"}
                            />
                          )}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Grid item xs={12} md={6}>
                          {" "}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              flexWrap: "wrap",
                              gap: { xs: 1.5, md: 0 },
                              alignItems: { xs: "flex-start", md: "center" },
                            }}
                          >
                            {/* Left: Title */}
                            <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                              <Chip
                                label="Recent Report"
                                sx={{
                                  px: 2,
                                  mb: 2,
                                  py: 1,
                                  fontWeight: 600,
                                  background:
                                    "linear-gradient(135deg, #0a140e 0%, #0a140e 100%)",
                                  color: "#fff",
                                  fontSize: "0.85rem",
                                  letterSpacing: 0.5,
                                  width: { xs: "100%", md: "auto" }, // 📱 full width
                                  justifyContent: "center",
                                }}
                              />
                            </Box>
                          </Box>{" "}
                        </Grid>

                        {loader ? (
                          <TableSkeleton />
                        ) : (
                          <div className="table-responsive animated-table-wrapper">
                            <table className="table table-bordered table-hover animated-table">
                              <thead className="table-forwarding">
                                <tr>
                                  <th>DID Number</th>
                                  <th>Forwarding No</th>
                                  <th>Status</th>
                                  <th>Duration</th>
                                  <th>Call Start</th>
                                </tr>
                              </thead>

                              <tbody>
                                {loader ? (
                                  <TableSkeleton />
                                ) : dataVal?.data?.length > 0 ? (
                                  dataVal.data
                                    ?.slice(0, 5)
                                    ?.map((item, index) => (
                                      <tr key={index} className="fade-row">
                                        <td>{item.did_number}</td>
                                        <td>{item.forwarded_number}</td>

                                        <td>
                                          <span
                                            style={{
                                              color:
                                                item.call_result === "ANSWERED"
                                                  ? "green"
                                                  : item.call_result ===
                                                      "MISSED"
                                                    ? "orange"
                                                    : item.call_result ===
                                                        "FAILED"
                                                      ? "red"
                                                      : "red",
                                            }}
                                          >
                                            {item.call_result}
                                          </span>
                                        </td>
                                        <td>{item.duration}</td>
                                        <td>
                                          {dayjs(item.start_at).format(
                                            "DD/MM/YYYY HH:mm",
                                          )}
                                        </td>
                                      </tr>
                                    ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      className="text-center py-4 fw-semibold text-muted"
                                    >
                                      No rows found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                          <Grid item xs={12} md={6}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: { xs: 1.5, md: 0 },
                                alignItems: { xs: "flex-start", md: "center" },
                              }}
                            >
                              {/* Left: Title */}
                              <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                                <Chip
                                  label="Campaign"
                                  sx={{
                                    px: 2,
                                    mb: 2,
                                    py: 1,
                                    fontWeight: 600,
                                    background:
                                      "linear-gradient(135deg, #0a140e 0%, #0a140e 100%)",
                                    color: "#fff",
                                    fontSize: "0.85rem",
                                    letterSpacing: 0.5,
                                    width: { xs: "100%", md: "auto" }, // 📱 full width
                                    justifyContent: "center",
                                  }}
                                />
                              </Box>
                            </Box>
                          </Grid>

                          {loader ? (
                            <TableSkeleton />
                          ) : (
                            <div className="table-responsive animated-table-wrapper">
                              <table className="table table-bordered table-hover animated-table">
                                <thead className="table-forwarding">
                                  <tr>
                                    <th>Campaign Name</th>
                                    <th>Total CC</th>
                                    <th>Active Buyer</th>
                                    <th>Daily Limit</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {callSummary?.data?.campaigns &&
                                  callSummary?.data?.campaigns.length > 0 ? (
                                    callSummary?.data?.campaigns
                                      .slice(0, visibleCount1)
                                      .map((item, index) => (
                                        <tr key={index} className="fade-row">
                                          <td>{item.campaign_name}</td>
                                          <td>{item.total_cc}</td>
                                          <td>{item.active_buyer_count}</td>
                                          <td>{item.total_daily_limit}</td>
                                        </tr>
                                      ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={5}
                                        className="text-center py-4 fw-semibold text-muted"
                                      >
                                        No rows found
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}

                          {/* Load More / Load Less */}
                          {!loader &&
                            callSummary?.data?.campaigns?.length > 5 && (
                              <Box
                                textAlign="center"
                                mt={2}
                                sx={{
                                  display: "flex",
                                  gap: 0,
                                  justifyContent: "center",
                                }}
                              >
                                {/* Load Less Button */}
                                {visibleCount1 > 5 && (
                                  <IconButton
                                    className="filter_reset_btn"
                                    onClick={handleLoadLess1}
                                  >
                                    Load Less
                                  </IconButton>
                                )}

                                {/* Load More Button */}
                                {visibleCount1 <
                                  callSummary?.data?.campaigns.length && (
                                  <IconButton
                                    className="redirect_all_button_clr"
                                    onClick={handleLoadMore1}
                                  >
                                    Load More
                                  </IconButton>
                                )}
                              </Box>
                            )}
                        </Grid>
                    </Grid>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default Dashboard;
